import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogEditMap({
  open,
  handleClose,
  data,
  handleOnChange,
  power,
  time,
  handleClickSubmit,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "15px",
            display: "flex",
            alignItems: "center",
            color: "#111111",
            marginTop: "1.2rem",
          }}
        >
          {"Edit Map"}
        </DialogTitle>
        <DialogTitle
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            display: "flex",
            color: "#111111",
            marginBottom: "-5px",
            marginTop: "-1rem",
          }}
        >
          Power
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <input
              style={{
                padding: "10px 15px",
                width: "15rem",
                height: "25px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              defaultValue={power}
              onChange={(e) => {
                handleOnChange(e, "max_khw");
              }}
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^0-9]/g, "");
              }}
              maxLength="4"
            ></input>
          </DialogContentText>
        </DialogContent>

        <DialogTitle
          sx={{
            height: "19px",
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "14px",
            display: "flex",
            marginBottom: "-5px",
            color: "#111111",
            marginTop: "-1rem",
          }}
        >
          Time
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <input
              style={{
                padding: "10px 15px",
                width: "15rem",
                height: "25px",
                background: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "6px",
              }}
              defaultValue={time}
              onChange={(e) => {
                handleOnChange(e, "time");
              }}
              onInput={(e) => {
                e.target.value = e.target.value
                  .trimStart()
                  .replace(/[^0-9]/g, "");
              }}
              maxLength="3"
            ></input>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{
              background: "#04AAD",
              marginRight: "1rem",
              width: "100.17px",
              height: "40px",
              marginBottom: "1.2rem",
              cursor: "pointer",
              fontSize: "12px",
            }}
            autoFocus
            onClick={() => handleClickSubmit()}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
